import NotificationItem from "./NotificationItem";

const NotificationsList = ({ notifications, setNotifications }) => {
  const handleRemove = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  return (
    <div className="bg-white rounded p-4 shadow">
      {notifications.length === 0 ? (
        <p className="text-gray-500 text-sm text-center">No notifications</p>
      ) : (
        notifications.map((n) => (
          <NotificationItem key={n.id} {...n} onClose={handleRemove} />
        ))
      )}
    </div>
  );
};

export default NotificationsList;
